import { ZonesIndex } from "@/components/Zones/ZonesIndex";

const ZonesIndexPage = () => {
  return <ZonesIndex />;
};

export default ZonesIndexPage;
